import React from 'react';
import wix from '../services/wix';
import * as biLogger from '../services/biLogger';
import { expandCollapseManager } from '@wix/chat-web';
import { triggerInteractivity } from '../services/bootstrap/chat-loader';
import { chatEventEmitter } from '@wix/chat-sdk';

export interface MobileProps {
  deviceType: string;
  host: string;
  primaryColor: string;
}

export interface MobileState {
  isMobile: boolean;
  isMobileOpen: boolean;
}

const mobile = (
  WrappedComponent: React.ComponentType<any>,
): React.ComponentType<any> => {
  return class extends React.Component<MobileProps, MobileState> {
    private wrappedComponent;

    constructor(props) {
      super(props);
      this.state = {
        isMobile: this.props.deviceType === 'mobile',
        isMobileOpen: false,
      };
    }

    componentDidMount() {
      const { host } = this.props;
      if (this.state.isMobile) {
        expandCollapseManager.registerOnCollapse(this.handleCollapse);
        wix.registerQab(() => {
          triggerInteractivity();
          wix.showMobileComponent();
          this.setState({ isMobileOpen: true });
          this.wrappedComponent.onPostExpand &&
            this.wrappedComponent.onPostExpand();
          biLogger.expandChatEvent({
            direction: 'uou',
            referrer: 'widget',
            host,
          });
        });

        chatEventEmitter.addListener(
          chatEventEmitter.CHAT_EVENTS.NEW_REALTIME_MESSAGE,
          () => {
            wix.updateQab({
              notifications: true,
              color: this.props.primaryColor,
            });
          },
        );
      }
    }

    handleMessageReceived = () => {
      if (this.state.isMobile) {
        wix.updateQab({
          visible: true,
          notifications: true,
          color: this.props.primaryColor,
        });
      }
    };

    handleCollapse = () => {
      if (this.state.isMobile) {
        wix.hideMobileComponent();
        this.setState({ isMobileOpen: false });
        wix.updateQab({
          visible: true,
          notifications: false,
          color: this.props.primaryColor,
        });
      }
    };

    render() {
      return (
        <WrappedComponent
          ref={component => (this.wrappedComponent = component)}
          onMessageReceived={this.handleMessageReceived}
          isMobileOpen={this.state.isMobileOpen}
          {...this.props}
        />
      );
    }
  };
};

export default mobile;
